// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IBSheetColsOptions {}

export interface IBSheetOptions {
  Cfg?: any
  Def?: any
  Cols?: IBSheetColsOptions
}
